import Link from '~/core/Link'

const RESET_PASSWORD_LINK = 'reset-password-link'
const RESET_PASSWORD_PATH = '/forget-password'
const RESET_PASSWORD_DEFAULT_TEXT = 'Reset password'

type ResetPasswordLinkPropsType = {
    placement: string
    disabled?: boolean
    text?: string
}

const ResetPasswordLink = (props: ResetPasswordLinkPropsType) => {
    const { placement, disabled, text = RESET_PASSWORD_DEFAULT_TEXT } = props

    return (
        <Link
            to={RESET_PASSWORD_PATH}
            name={RESET_PASSWORD_LINK}
            data-test-target={RESET_PASSWORD_LINK}
            placement={placement}
            disabled={disabled}
        >
            {text}
        </Link>
    )
}

export default ResetPasswordLink
